import { localize } from '@/core/filters';

/**
 * Wrapper for displaying indicator in indicators list
 * of Settings panel
 */
export class IndicatorItem {
    /** The indicator name as received from the backend */
    private readonly _name: string;

    /**
     * Creates instance of the wrapper
     * @param { string } name The indicator name from the backend
     */
    constructor(name: string) {
        if (!name) { throw new Error('name is not set'); }

        this._name = name;
    }

    /** The indicator name from the backend */
    public get name(): string {
        return this._name;
    }
    /** The indicator name to display */
    public get displayName(): string {
        // TODO May be it is neccessary to memoize this operation result
        return localize('Indicator_' + this._name);
    }
}
